import React, { useState } from 'react';
import { Input, Form, Modal, Button, message, Checkbox } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { serverFetch } from '../../server';
import './auth.css';

const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const GuestContact = ({ onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [saved] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('guestContact')) || {};
    } catch (e) {
      return {};
    }
  });
  const [phone, setPhone] = useState(saved.phone || '');
  const [email, setEmail] = useState(saved.email || '');
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const isPhoneValid = phone && phone.indexOf('_') < 0 && phone.replace(/\s/g, '').length >= 12;
  const isEmailValid = emailRegex.test((email || '').trim());
  const disabled = !agreed || !isPhoneValid || !isEmailValid || loading;

  const onSubmit = () => {
    setLoading(true);
    serverFetch('account/guest-signin', {
      method: 'POST',
      bodyData: { phone: phone.replace(/\s/g, ''), email: email.trim() }
    })
      .then((data) => {
        setLoading(false);
        try {
          localStorage.setItem('guestContact', JSON.stringify({ phone, email: email.trim() }));
        } catch (e) {
          // localStorage может быть недоступен
        }
        onSuccess(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.UserMessage || 'Ошибка');
      });
  };

  return (
    <Modal forceRender open title={<div className='auth-close-btn'></div>} closable={true} footer={null} width={340} onCancel={onClose}>
      <Form colon={false} form={form} layout='vertical'>
        <div className='auth-title'>Данные для покупки</div>
        <Form.Item>
          <Checkbox checked={agreed} onChange={e => setAgreed(e.target.checked)} style={{fontSize: 12}}>
            Согласен с обработкой конфиденциальных данных в соответствии с <a href='/article/agreement' target='_blank'>политикой конфиденциальности</a>
          </Checkbox>
          <div style={{ fontSize: 12, marginTop: 8, color: 'rgba(0, 0, 0, 0.45)', lineHeight: 1.5 }}>
            Чек об оплате будет отправлен на указанную почту
          </div>
        </Form.Item>
        <Form.Item label='Телефон'>
          <MaskedInput size='large' mask={'+7 000 000 00 00'} value={phone} onChange={e => setPhone(e.target.value)} placeholder='+7 ___ ___ __ __' type='tel' inputMode='tel' disabled={!agreed}/>
        </Form.Item>
        <Form.Item label='Email'>
          <Input size='large' type='email' value={email} onChange={e => setEmail(e.target.value)} placeholder='email@example.com' disabled={!agreed}/>
        </Form.Item>
        <Form.Item>
          <Button className='auth-btn' size='large' onClick={onSubmit} disabled={disabled} loading={loading} block>Продолжить</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GuestContact;
